export const prepayHistoryConstants = {
    GET_PREPAY_HISTORY_REQUEST: 'GET_PREPAY_HISTORY_REQUEST',
    GET_PREPAY_HISTORY_SUCCESS: 'GET_PREPAY_HISTORY_SUCCESS',
    GET_PREPAY_HISTORY_FAILURE: 'GET_PREPAY_HISTORY_FAILURE',

    GET_PREPAY_PURCHASE_HISTORY_DETAILS_REQUEST: 'GET_PREPAY_PURCHASE_HISTORY_DETAILS_REQUEST',
    GET_PREPAY_PURCHASE_HISTORY_DETAILS_SUCCESS: 'GET_PREPAY_PURCHASE_HISTORY_DETAILS_SUCCESS',
    GET_PREPAY_PURCHASE_HISTORY_DETAILS_FAILURE: 'GET_PREPAY_PURCHASE_HISTORY_DETAILS_FAILURE'
}